/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { SessionStorageService } from './session-storage.service';
import { Shipment } from '../shipment/models/shipment';
import { ShipmentDelivery } from '../shipment/models/delivery/shipment-delivery.model';
import { DeliveryNoteRequest } from '../shipment/models/delivery-note-request';

@Injectable()
export class ReportsService {

    reportsApiUrl: string;

    constructor(private http: HttpClient, private sessionStorageService: SessionStorageService) {
        this.reportsApiUrl = `${environment.reportsApiUrl}`;
    }

    generateWayBill(orderQuery: Shipment, orderDelivery: ShipmentDelivery) {
        return this.http.post<String>(`${this.reportsApiUrl}waybill/download`, new DeliveryNoteRequest(orderQuery, orderDelivery), {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST, OPTIONS', // Allow POST and OPTIONS
                'Access-Control-Allow-Headers': 'Content-Type' // Allow Content-Type header
            }
        });
    }



}
